const SelectionClipboardContributionID = 'editor.contrib.selectionClipboard';
export { SelectionClipboardContributionID };
